// Curve loss vertex schema
// Passive device with user-defined DP curve. Dual elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema, PressureDropCurveSchema } from '../base/common';

export const CurveLossVertexSchema = BaseVertexSchema.extend({
  type: z.literal('curve_loss'),
  inlet_elevation: ValueWithUnitSchema,
  outlet_elevation: ValueWithUnitSchema,
  pressure_drop_curve: PressureDropCurveSchema,
});

export type CurveLossVertex = z.infer<typeof CurveLossVertexSchema>;
